import React from 'react';
import styled from 'styled-components';

const ServicesSection = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #6a1b9a;
  font-size: 36px;
  margin-bottom: 15px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 18px;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  height: 4px;
  width: 80px;
  background: linear-gradient(to right, #00b8d4, #6a1b9a);
  margin: 0 auto 40px;
`;

const ServicesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  padding: 0 20px;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled.div`
  background-color: #f8f2ff;
  border-radius: 10px;
  padding: 30px;
  transition: transform 0.3s, box-shadow 0.3s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

const ServiceIcon = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ServiceTitle = styled.h3`
  color: #6a1b9a;
  font-size: 22px;
  margin-bottom: 15px;
`;

const ServiceDescription = styled.p`
  color: #555;
  font-size: 16px;
  line-height: 1.6;
`;

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '/icons/icon-preventive.png',
      title: 'Odontopediatria Preventiva',
      description: 'Cuidados preventivos para garantir a saúde bucal desde os primeiros dentinhos, evitando problemas futuros e promovendo hábitos saudáveis.'
    },
    {
      id: 2,
      icon: '/icons/icon-orthodontics.png',
      title: 'Ortodontia Preventiva',
      description: 'Acompanhamento do desenvolvimento da arcada dentária, prevenindo e corrigindo problemas de alinhamento desde cedo.'
    },
    {
      id: 3,
      icon: '/icons/icon-education.png',
      title: 'Educação em Saúde Bucal',
      description: 'Orientações lúdicas e educativas para crianças e pais sobre a importância da higiene bucal e alimentação saudável.'
    },
    {
      id: 4,
      icon: '/icons/icon-treatment.png',
      title: 'Tratamentos Restauradores',
      description: 'Restaurações estéticas e funcionais adaptadas às necessidades específicas dos dentes de leite e permanentes.'
    },
    {
      id: 5,
      icon: '/icons/icon-behavior.png',
      title: 'Manejo Comportamental',
      description: 'Técnicas especializadas para tornar a experiência odontológica positiva, reduzindo a ansiedade e construindo confiança.'
    },
    {
      id: 6,
      icon: '/icons/icon-emergency.png',
      title: 'Atendimento de Urgências',
      description: 'Pronto atendimento para traumas dentários, dores e outras emergências odontológicas infantis.'
    }
  ];

  return (
    <ServicesSection id="especialidades">
      <SectionTitle>Nossas Especialidades</SectionTitle>
      <SectionSubtitle>
        Conheça os Tratamentos e Especialidades do Ateliê Dentinhos de Leite
      </SectionSubtitle>
      <Divider />
      <ServicesContainer>
        {services.map(service => (
          <ServiceCard key={service.id}>
            <ServiceIcon>
              <img src={service.icon} alt={service.title} />
            </ServiceIcon>
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
          </ServiceCard>
        ))}
      </ServicesContainer>
    </ServicesSection>
  );
};

export default Services;
